import moment from 'moment';
import React, { ChangeEvent, createRef, useState } from 'react';
import { Button, Container } from 'react-bootstrap';
import { Tooltip } from 'antd';
import { Search, CurrencyEuro, Envelope, Wallet2, BootstrapReboot } from 'react-bootstrap-icons';
import { withTranslation, WithTranslation } from 'react-i18next';
import { withRouter } from 'react-router';
import { reactFormatter } from 'react-tabulator';
import 'react-calendar/dist/Calendar.css';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

import validator from 'validator';
import constants from '../../constants';
import ChangeMailRequest from '../../Model/changeMailRequest';
import './PurchasesList.scss';
//import 'antd/dist/antd.css';
import {
  getPlanetPriceInDate,
  getAlgorandPriceInDate,
  replaceChangeMailOrder,
  loadCounts,
  deleteOrderCall,
  downloadInvoiceHandler,
  downloadCreditNoteHandler
} from '../../api/purchases';
import Loader from '../../common-components/loader';
import CustomAlert, { CustomAlertType } from '../../Components/CustomAlert';
import PurchasesTopCard from '../../Components/Purchases/sub-components/PurchasesTopCard';
import { IOrder } from '../../Components/Purchases/orderDetails';
import { useTranslation } from 'react-i18next';
import ExportAndDownloadModal from '../../Components/Purchases/sub-components/modals/ExportAndDownloadModal';
import PriceInDateModal from '../../Components/Purchases/sub-components/modals/PriceInDateModal';
import ChangeMailModal from '../../Components/Purchases/sub-components/modals/ChangeMailModal';
import RefundOrderModal from '../../Components/Purchases/sub-components/modals/RefundOrderModal';
import SelectedPurchaseModal from '../../Components/Purchases/sub-components/modals/SelectedPurchaseModal';
import TableView from '../../Components/tableView';
import OrderPayment from '../../Model/Payment';
import { PaymentsService } from '../../services/paymentsService';
import authAxios from '../../authorization/axios';


type OrderPaymentWithPaymentType = OrderPayment & { type: string, currency: string; };


interface IPurchasesState {
  loading: boolean,
  selectedPurchase?: IOrder,
  showCounts: boolean,
  showError: boolean,
  showPriceHistory?: IOrder & { paymentType: { currency: string } },
  showModalOrderRef: boolean,
  priceInDate?: {
    total: number,
    total_planets: number,
    planet_eur: number,
    planet_usd: number,
    coin: string
  },
  priceDate: Date,
  errorMessage?: string,
  export: {
    showModal: boolean,
    source?: string | undefined,
    table: boolean,
    from: Date,
    to: Date,
    title: string,
    status: Number
  },
  counts: {
    total: number | string,
    sources: { [key: string]: number }
  },
  calendar: boolean,
  date?: Date | Date[] | null,
  downloadId: Number,
  showModal: boolean,
  orderId: number,
  validated: boolean,
  newMail: string,
  pSource: string,
  dateProductRefundable: string,
}

function str2bytes(str: String) {
  const bytes = new Uint8Array(str.length);
  // eslint-disable-next-line operator-assignment
  for (let i = 0; i < str.length; i = i + 1) {
    bytes[i] = str.charCodeAt(i);
  }
  return bytes;
}

/* eslint-disable i18next/no-literal-string */
const Actions = (context: any) => {
  // eslint-disable-next-line no-underscore-dangle
  const cellData = context.cell._cell.row.data;
  return <>
    <Tooltip title={context.props.t('ORDER_DETAILS')}>
      <Button onClick={() => {
        // eslint-disable-next-line no-underscore-dangle
        context.props.rowSelected({ _row: { data: cellData } });
      }} size='sm' style={{ marginRight: '1em', background: 'green', borderColor: 'green', color: 'white' }} color='success'>
        <Search />
      </Button>
    </Tooltip>
    <Tooltip title={context.props.t('CHANGE_EMAIL')}>
      <Button onClick={() => { context.props.changeMail(cellData.id); }} size='sm'
        style={{ marginRight: '1em', background: 'green', borderColor: 'green', color: 'white' }} color='danger'>
        <Envelope />
      </Button>
    </Tooltip>
    {/* <Tooltip title={context.props.t('DOWNLOAD_INVOICE')}>
      <Button size='sm' style={{ marginRight: '1em' }} color='warning'>
        <Download onClick={() => {
          context.props.downloadInvoice(cellData.id);
        }} />
      </Button>
    </Tooltip>
    {
      ['refunded', 'partial_refund'].indexOf(cellData.status) > -1 &&
      <Tooltip title={context.props.t('DOWNLOAD_CREDIT_NOTE')}>
        <Button size='sm' style={{ marginRight: '1em', background: 'red' }}>
          <Download onClick={() => {
            context.props.downloadCreditNote(cellData.id);
          }} />
        </Button>
      </Tooltip>
    } */}

    <Tooltip title={context.props.t('ORDER_REFUNDABLE')}>
      <Button size='sm' style={{ marginRight: '1em', color: 'white' }} color='warning'>
        <BootstrapReboot style={{ fontSize: 18 }} onClick={() => {
          context.props.orderRefoundable(cellData.id);
        }} />
      </Button>
    </Tooltip>
    <Tooltip title={context.props.t('PRICE_IN_DATE')}>
      <Button size='sm' style={{ marginRight: '1em', color: 'white' }} color='warning'>
        <CurrencyEuro onClick={() => {
          context.props.showPriceInDate(cellData);
        }} />
      </Button>
    </Tooltip>
    <Tooltip title={context.props.t('PAYMENT_DETAILS')}>
      <Button size='sm' style={{ marginRight: '1em', color: 'white' }}>
        <Wallet2 onClick={() => {
          context.props.paymentDetails(cellData);
        }} />
      </Button>
    </Tooltip>
    {/* <Tooltip title={context.props.t('DELETE_ORDER')}>
      <Button size='sm' style={{ background: 'red', borderColor: 'red' }} color='danger'>
        <Trash onClick={() => {
          context.props.deleteOrder(cellData.id);
        }} />
      </Button>
    </Tooltip> */}
  </>;
};

const Purchases = (props: WithTranslation) => {
  let refresh: boolean = true;
  const { t } = useTranslation();
  const purchaseTable = createRef<TableView>();
  const [loading, setLoading] = useState(false);
  //const [calendar, setCalendar] = useState();
  const [selectedPurchase, setSelectedPurchase] = useState();
  const [showCounts, setShowCounts] = useState(false);
  const [priceDate, setPriceDate] = useState(new Date());
  const [showModalOrderRef, setShowModalOrderRef] = useState(false);
  const [exports, setExports] = useState<IPurchasesState['export']>({
    showModal: false,
    source: '',
    table: false,
    from: new Date(),
    to: new Date(),
    title: '',
    status: 0
  });
  const [counts, setCounts] = useState({
    total: '-',
    sources: {}
  });

  const paymentsService: PaymentsService = new PaymentsService();
  /*
    const [calendarInitial, setCalendarInitial] = useState([
          new DateObject().subtract(4, 'days'),
          new DateObject().add(4, 'days')
    ]);

    const [downloadId, setDownloadId] = useState(0);
    */
  //const [modalVisible, setModalVisible] = useState<IPurchasesState['showModal']>(false);
  const [orderId, setOrderId] = useState(0);
  const [validated, setValidated] = useState(false);
  const [newMail, setNewMail] = useState('');
  const [showError, setShowError] = useState(false);
  /*
    const [calendarStart, setCalendarStart] = useState(new DateObject());
    const [calendarEnd, setCalendarEnd] = useState(new DateObject());
    const [pSource, setPSource] = useState('');
    const [dateProductRefundable, setDateProductRefundable] = useState('');
  */
  const [showPriceHistory, setShowPriceHistory] = useState<IPurchasesState['showPriceHistory']>();
  const [priceInDate, setPriceInDate] = useState<IPurchasesState['priceInDate']>();
  const [errorMessage, setErrorMessage] = useState<IPurchasesState['errorMessage']>('');
  const [showModals, setShowModals] = useState<IPurchasesState['showModal']>(false);
  console.log(showModals);

  const loadDetail = (purchase: any) => {
    window.open(`${window.location.origin}/#/purchases/${purchase?.id}`);
    // (this.props as any).history.push({
    //   pathname: `/purchases/${purchase?.id}`
    // });
  };
  const rowSelected = (row: any) => {
    // eslint-disable-next-line no-underscore-dangle
    const rowData = row._row.data;
    loadDetail(rowData);
  };

  // loadCounts is called from api/purchases.ts
  // loadCounts = async () => {
  //   const result = await http.get(`${constants.api.getPurchasesCounts}`);
  //   if (result.data && result.data.success && result.data.data) {
  //     this.setState({ counts: result.data.data });
  //   }
  // };

  const toggleCounts = () => {
    setShowCounts(!showCounts);
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const changeMail = async (id: number) => {
    setShowModals(true);
    setOrderId(id);
    return null;
  };

  const getSensorsAndLicensesReport = () => {
    const { source, from, to } = exports;
    const fromQuery = moment(from).toDate().toISOString();
    const sourceQuery = source ? `source=${encodeURIComponent(source)}` : '';
    const toQuery = moment(to).toDate().toISOString();
    const queries = `?${sourceQuery}&from=${fromQuery}&to=${toQuery}`;
    const url = `${constants.api.base}/stats/sensors-licenses-overview/xlsx${queries}`;
    authAxios.get(url).then((res: any) => {
      if (res.data?.success) {
        // window.open(`data:${res.data.data.mime};base64,${res.data.data.base64}`, '_blank');
        const fromDate = from ? `-${moment(from).format('YYYY-MM-DD')}` : '';
        const toDate = to ? `-${moment(to).format('YYYY-MM-DD')}` : '';
        let sourceLabel = '';
        if (source) {
          if (source.indexOf('.us') > -1) {
            sourceLabel = '-US';
          } else if (source.indexOf('.io') > -1) {
            sourceLabel = '-EU';
          } else {
            sourceLabel = '-B2B';
          }
        }
        const a = document.createElement('a');
        a.href = `data:${res.data.data.mime};base64,${res.data.data.base64}`;
        a.download = `${res.data.data.filename}${sourceLabel}${fromDate}${toDate}`;
        a.click();
      }
    });
  };

  const downloadAPI = (url: string) => {
    setLoading(true);
    authAxios.get(url).then((res: any) => {
      setLoading(false);
      if (res.status === 200) {
        const blob = new Blob([str2bytes(res.data)], { type: 'application/zip' });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = '1.zip';
        a.click();
      }
    });
  };

  const getOverviewOrders = () => {
    setLoading(true);
    const { source, from, to, table, status } = exports;
    const sourceQuery = source ? `source=${encodeURIComponent(source)}` : '';
    const fromQuery = status === 0 ? moment(from).toDate().getTime() : moment(from).toDate().toISOString();
    let toQuery: Date | number | string = moment(to).toDate();
    if (status === 0) {
      toQuery.setDate(toQuery.getDate() + 1);
    }

    toQuery.setHours(23, 59, 999);
    toQuery = status === 0 ? toQuery.getTime() : toQuery.toISOString();
    const offset = new Date().getTimezoneOffset() * -1;
    const prefix = table ? 'table-' : '';
    let url = '';

    if (status === 0) {
      url = `${constants.api.base}/orders/${prefix}export?${sourceQuery}&from=${fromQuery}&to=${toQuery}&offset=${offset}`;
      // window.open(url, '_blank');
      authAxios.get(url).then((res: any) => {
        if (res.data?.success) {
          // window.open(`data:${res.data.data.mime};base64,${res.data.data.base64}`, '_blank');
          const a = document.createElement('a');
          a.href = `data:${res.data.data.mime};base64,${res.data.data.base64}`;
          a.download = `${prefix}${res.data.data.filename}`;
          a.click();
        }
        setLoading(false);
      }).catch(err => {
        console.error(err);
        setLoading(false);
      });
    } else {
      setLoading(false);
      url = `${constants.api.base}/orders/invoices?from=${fromQuery}&to=${toQuery}&offset=${offset}&${sourceQuery}`;
      downloadAPI(url);
    }
  };

  const getDownloadFunction = () => {
    const { title } = exports;
    switch (title) {
      case t('DOWNLOAD_SENSORS_LICENSES_REPORT'):
        return getSensorsAndLicensesReport;
      default:
        return getOverviewOrders;
    }
  };
  const openExportModal = async (source: string = '', table: boolean = false,
    title: string = t('EXPORT_ORDERS_MODAL_TITLE'), status: Number = 0) => {
    console.log(source);
    exports.source = source;
    exports.table = table;
    exports.showModal = true;
    exports.title = title;
    exports.status = status;
    setExports({ ...exports });
    console.log(exports.source);
  };

  const handleModalClose = () => {
    exports.showModal = false;
    exports.source = '';
    // setExports({ ...exports, showModal: false, source: '' });
    setExports({ ...exports });
  };

  const downloadInvoice = async (id: number) => {
    setLoading(true);
    const url = `${constants.api.base}/orders/${id}/invoice`;
    // window.open(url, '_blank');
    try {
      const res = await downloadInvoiceHandler(url, setLoading);
      if (res.data?.success) {
        const a = document.createElement('a');
        a.href = `data:${res.data.data.mime};base64,${res.data.data.base64}`;
        a.download = res.data.data.filename;
        a.click();
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const downloadCreditNote = async (id: number) => {
    setLoading(true);
    const url = `${constants.api.base}/orders/${id}/credit-note`;
    // window.open(url, '_blank');
    try {
      const res: any = await downloadCreditNoteHandler(url);
      if (res.data?.success) {
        const a = document.createElement('a');
        a.href = `data:${res.data.data.mime};base64,${res.data.data.base64}`;
        a.download = res.data.data.filename;
        a.click();
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
    setLoading(false);
  };
  /* unused
    const onChangeDate = (date: Date | Date[] | null | undefined) => {
      setState({ ...state, date, calendar: false });
    };
  */
  const deleteOrder = async (id: number) => {
    const check = window.confirm(t('CONFIRM_ORDER_DELETE'));
    if (check) {
      const result = await deleteOrderCall(id, constants);
      try {
        const res: any = await loadCounts(constants);
        if (res.data && res.data.success && res.data.data) {
          setCounts(res.data.data);
        }
      } catch (err) {
        console.log(err);
      }
      refresh = false;
      // setState({ ...state });
      refresh = true;
      // setState({ ...state });
      return result;
    }
    return null;
  };
  /* unused
    const proceedChangeDate = (values: DateObject | DateObject[] | null) => {
      const temp = values;
      if (Array.isArray(temp)) {
        if (temp.length > 1) {
          setState({ ...state, calendarStart: temp[0], calendarEnd: temp[1] });
        } else if (temp.length === 1) {
          setState({ ...state, calendarStart: temp[0], calendarEnd: temp[0] });
        }
      }
    }
  */
  const onChangeValue = (e: ChangeEvent<HTMLInputElement>) => {
    const field = e.target.id;
    const { value } = e.target;

    switch (field) {
      case 'newMail': {
        setNewMail(value);
        break;
      }
      default:
        break;
    }
  };

  const showPriceInDate = async (row: any) => {
    const paymentMethods = await paymentsService.getPaymentsFromOrderId(row.id);
    row.paymentTypes = paymentMethods;
    if (paymentMethods.length === 1) {
      row.currentPaymentType = paymentMethods[0];
    }
    setShowPriceHistory(row);
  };

  const hidePriceInDate = () => {
    setShowPriceHistory(undefined);
    setPriceInDate(undefined);
  };

  const paymentDetails = (rowData: any) => {
    (props as any).history.push({
      pathname: `/orders/${rowData.id}/payments`
    });
  };

  const orderRefoundable = (ordId: number) => {
    setShowModalOrderRef(true);
    setOrderId(ordId);
  };

  const statusOptions = {
    'refunded': t('REFUNDED'),
    'partial_refund': t('PARTIAL_REFUND'),
    'failed_refund': t('FAILED_REFUND'),
    '': t('ALL')
  };

  const columns = [
    { title: t('Order ID'), field: 'order_id', sorter: 'string', headerFilter: 'input' },
    { title: t('Source'), field: 'source', sorter: 'string', headerFilter: 'input' },
    {
      title: t('MAIL'),
      field: 'contact.mail',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('Date'),
      field: 'date',
      sorter: 'date',
      headerFilter: 'input',
      formatter: (cell: any) => {
        const locale = (window.navigator as any).userLanguage || window.navigator.language;
        // eslint-disable-next-line no-underscore-dangle
        return moment(cell._cell.value).locale(locale).format('DD/MM/YYYY HH:mm');
      }
    },
    {
      title: t('ITEMS'),
      field: 'productsDescription',
      sorter: 'string',
      headerFilter: false,
      headerSort: false
    },
    {
      title: t('SKU'),
      field: 'productsSkus',
      sorter: 'string',
      headerFilter: false,
      headerSort: false
    },
    { title: t('TOTAL'), field: 'total', sorter: 'string', headerFilter: 'input' },
    {
      title: t('Currency'),
      field: 'currency',
      sorter: 'string',
      filterField: 'currency',
      headerFilter: 'input'
    },
    // {
    //   title: t('Currency'),
    //   field: 'paymentType.currency',
    //   sorter: 'string',
    //   filterField: 'payment_types.currency',
    //   headerFilter: 'input'
    // },
    {
      title: t('PAYMENT_TYPE'),
      field: 'paymentMethods',
      sorter: 'string',
      filterField: 'paymentMethods',
      headerFilter: 'input'
    },
    {
      title: t('Status'),
      field: 'status',
      sorter: 'string',
      headerFilter: 'select',
      editorParams: statusOptions,
      headerFilterParams: statusOptions,
      formatter: (cell: any) => {
        const i18nLabel = (cell.getValue() || 'COMPLETED').toUpperCase();
        let label = t(i18nLabel);
        return label;
      }
    },
    {
      title: '',
      sortable: false,
      formatter: reactFormatter(<Actions props={{
        rowSelected: rowSelected.bind(this),
        changeMail: changeMail.bind(this),
        downloadInvoice: downloadInvoice.bind(this),
        downloadCreditNote: downloadCreditNote.bind(this),
        deleteOrder: deleteOrder.bind(this),
        showPriceInDate: showPriceInDate.bind(this),
        paymentDetails: paymentDetails.bind(this),
        orderRefoundable: orderRefoundable.bind(this),
        t: t
      }} />),
      headerSort: false,
      width: '400'
    }
  ];

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (form.checkValidity()) {
      if (validator.isEmail(newMail)) {
        setValidated(true);
        setShowModals(false);
        setLoading(true);
        const submitData: ChangeMailRequest = {
          mail: newMail
        };
        setLoading(true);
        try {
          const res = await replaceChangeMailOrder(orderId, submitData, constants);
          if (res.data.success) {
            setLoading(false);
            purchaseTable.current?.reloadData();
            setNewMail('');
          }
        } catch (err: any) {
          setShowError(true);
          setErrorMessage(err.response?.data.errorMessage);
          setNewMail(''); console.log(err);
        }
      } else {
        setLoading(false);
        setShowError(true);
        setErrorMessage('Not validated Email');
      }
    } else {
      setLoading(false);
      setValidated(false);
    }
  };

  const closeModal = () => setShowModals(false);




  const getCurrency = () => {
    const currency = showPriceHistory?.paymentType?.currency;
    console.log(showPriceHistory);
    switch (currency) {
      case 'EUR':
      case 'ALGO':
        return '€';
      case 'USD':
        return '$';
      case 'PLANETS':
        if (showPriceHistory?.note && showPriceHistory?.note?.indexOf('PLANETS -') > -1) {
          const isUSD = showPriceHistory?.source && showPriceHistory?.source?.indexOf('.us') > -1;
          return isUSD ? '$' : '€';
        }
        return 'PLANETS';
      default:
        return currency;
    }
  };

  const calcCovertion = async (paymentMethod: OrderPaymentWithPaymentType) => {
    setLoading(true);
    if (priceDate) {
      const order = showPriceHistory;
      const algorandGeko: any = await getAlgorandPriceInDate(priceDate);
      const planetsGeko: any = await getPlanetPriceInDate(priceDate);
      if (showPriceHistory && planetsGeko) {
        let totalPlanets = 0;
        let total = (showPriceHistory.total ?? 0) * (paymentMethod.percentage / 100);
        // const algorandEur = total / (algorandGeko.eur ?? 100);
        // const algorandUsd = total / (algorandGeko.usd ?? 100);
        const planetsEur = total / (planetsGeko.eur ?? 100);
        const planetsUsd = total / (planetsGeko.usd ?? 100);
        const currency = paymentMethod?.currency;

        let coin = 'PLANETS';
        let covertion = {
          eur: planetsGeko.eur,
          usd: planetsGeko.usd
        };
        switch (currency) {
          case 'EUR':
            totalPlanets = planetsEur;
            break;
          case 'USD':
            totalPlanets = planetsUsd;
            break;
          case 'PLANETS':
            totalPlanets = total / (planetsGeko[order?.currency === 'EUR' ? 'eur' : 'usd'] ?? 100);
            break;
          case 'ALGO':
            coin = 'ALGO';
            totalPlanets = total / (algorandGeko[order?.currency === 'EUR' ? 'eur' : 'usd'] ?? 100);
            covertion = {
              eur: algorandGeko.eur,
              usd: algorandGeko.usd
            };
            break;
          default:
            totalPlanets = showPriceHistory.total as number;
            break;
        }
        setLoading(false);
        setPriceInDate({
          ...priceInDate,
          total,
          coin,
          total_planets: totalPlanets,
          planet_usd: Math.round((covertion.usd ?? 0) * 1000000) / 1000000,
          planet_eur: Math.round((covertion.eur ?? 0) * 1000000) / 1000000

        });
        return;
      }
      setLoading(false);
      setPriceInDate(undefined);
    }
  };

  const count = Object.keys(counts.sources);
  const { showModal, title } = exports;
  /* @ts-ignore next-line */
  //const { newMail } = this.state;

  return (
    <>
      <Container fluid>
        <PurchasesTopCard
          t={t}
          countsState={counts}
          counts={count}
          showCounts={showCounts}
          openExportModal={openExportModal}
          toggleCounts={toggleCounts}

        />

        {refresh &&
          <TableView
            t={t}
            ref={purchaseTable}
            api={constants.api.getOrders}
            columns={columns}
            id={'purchases'}
            params={{ includes: ['billing', 'contact', 'payment_type', 'items'].join(',') }}
          />}

        <SelectedPurchaseModal
          t={t}
          selectedPurchase={selectedPurchase}
          setSelectedPurchase={setSelectedPurchase}
        />
        <Loader fullscreen={true} visible={loading} />
      </Container>


      {/* MODAL SECTIONS */}

      <RefundOrderModal
        showModalOrderRef={showModalOrderRef}
        setShowModalOrderRef={setShowModalOrderRef}
        t={t}
        orderId={orderId}
      />
      <ExportAndDownloadModal
        t={t}
        title={title}
        showModal={showModal}
        export={exports}
        handleModalClose={handleModalClose}
        getDownloadFunction={getDownloadFunction}
      />

      <PriceInDateModal
        t={t}
        calcCovertion={calcCovertion}
        showPriceHistory={showPriceHistory}
        hidePriceInDate={hidePriceInDate}
        title={title}
        setPriceDate={setPriceDate}
        priceInDate={priceInDate}
        getCurrency={getCurrency}
      />
      <ChangeMailModal
        t={t}
        showModal={showModals}
        closeModal={closeModal}
        validated={validated}
        handleSubmit={handleSubmit}
        newMail={newMail}
        onChangeValue={onChangeValue}
      />
      <CustomAlert
        type={CustomAlertType.ERROR}
        show={showError}
        message={errorMessage}
        onClose={() => {
          setShowError(false);
          setErrorMessage(undefined);
        }}
      />
    </>
  );
};

export default withTranslation()(withRouter(Purchases as any));